export enum ProblemResolutionStopOutcome {
  Picked = "picked",
  Counted = "counted",
  NotHere = "not_here",
  NoneInWarehouse = "none_in_warehouse",
}
